import { forwardRef, useMemo } from 'react'
import NextLink from 'next/link'
import { Link as MuiLink } from '@mui/material'
import {
	isFullURL,
	isEmailTo,
	isTel,
	isJavascript,
	isSingleHashtag,
	addTrailingSlash,
	addLeadingSlash,
} from '@bluheadless/ui-logic/src/utils/url'
import BhNextLink from './next-link'

const Link = forwardRef(function LinkComponent({ href, forceInternal, children, as, ...props }, ref) {
	const _as = as ?? href?.as ?? null
	const isInternal = useMemo(
		() =>
			forceInternal ??
			(href && !isFullURL(href) && !isEmailTo(href) && !isTel(href) && !isJavascript(href) && !isSingleHashtag(href)),
		[forceInternal, href]
	)

	const transformedHref = useMemo(() => {
		if (isInternal) {
			if (typeof href === 'object') {
				// NOTE: if `as`, do not pass it to the `href` prop
				// since it'll throw warnings in the console.
				// eslint-disable-next-line no-unused-vars
				const { as, ...hrefRest } = href
				return { ...hrefRest, pathname: addLeadingSlash(addTrailingSlash(href.pathname)) }
			} else {
				return addLeadingSlash(addTrailingSlash(href))
			}
		}
	}, [href, isInternal])

	return isInternal ? (
		<MuiLink ref={ref} href={transformedHref} {...props} _as={_as} component={BhNextLink}>
			{children}
		</MuiLink>
	) : (
		<MuiLink ref={ref} href={href} {...props}>
			{children}
		</MuiLink>
	)
})

Link.propTypes = {
	...NextLink.propTypes,
	...MuiLink.propTypes,
}
Link.defaultProps = {
	...NextLink.defaultProps,
	...MuiLink.defaultProps,
}

export default Link
